import React, { useEffect } from "react";
import { defineMessages } from "react-intl";
import { Button } from "../../../components/button/Buttons.js";
import "../../../components/button/EditButton.js";
import { BulkModalContent } from "../../../components/modal/BulkModalContent.js";
import "../../../components/modal/BulkModalProvider.js";
import { BulkModalTitle } from "../../../components/modal/BulkModalTitle.js";
import "../../../components/modal/ModalButtons.js";
import { ModalFooter } from "../../../components/modal/ModalFooter.js";
import "@mui/material";
import "../../../components/modal/Modal.style.js";
import "../../../components/error/ErrorAccordion.js";
import "../../../components/error/ErrorDetails.js";
import "../../../components/error/localize.js";
import "../../../components/error/ErrorModal.js";
import "../../../components/error/GlobalServerErrorMessage.js";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "rxjs/operators";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "../../../components/modal/types.js";
import "../../../components/modal/ActionConfirmationModal.js";
import { useBulkOperationExecution, useExecutionActions } from "../hooks.js";
const localized = defineMessages({
  bulkStepExecutionSummaryModalHeader: {
    id: "BulkStepExecutionSummary_modalHeader",
    defaultMessage: "Summary"
  },
  bulkStepExecutionSummaryModalConfirm: {
    id: "BulkStepExecutionSummary_modalConfirm",
    defaultMessage: "Confirm"
  },
  bulkStepExecutionSummaryModalRetry: {
    id: "BulkStepExecutionSummary_modalRetry",
    defaultMessage: "Retry"
  }
});
function withBulkStepExecutionSummary(WrappedComponent) {
  return function BulkStepExecutionSummary({
    onNext,
    hasRetry = false,
    actionsData,
    affectedEntityName,
    withFlexibleGrid,
    bulkOperationEntityType
  }) {
    const { actionItems, isExecutionInProgress, isExecutionFailed, failedOperationKeys } = useBulkOperationExecution(
      "BulkExecutionSummary",
      bulkOperationEntityType
    );
    const { performExecution, retryExecution } = useExecutionActions(actionItems, actionsData);
    useEffect(() => {
      performExecution();
    }, []);
    function handlePrevClick() {
      retryExecution();
    }
    function handleNextClick() {
      onNext();
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(BulkModalTitle, { title: localized.bulkStepExecutionSummaryModalHeader }), /* @__PURE__ */ React.createElement(BulkModalContent, null, Object.keys(actionItems).map((actionKey) => /* @__PURE__ */ React.createElement(
      WrappedComponent,
      {
        key: `summaryDetails-${actionKey}`,
        actionItems: actionItems[actionKey],
        actionKey: actionItems[actionKey]?.[0]?.actionKey,
        affectedEntityName,
        isProcessingFinished: !isExecutionInProgress,
        isOperationFailed: failedOperationKeys.includes(actionKey),
        withFlexibleGrid
      }
    ))), /* @__PURE__ */ React.createElement(ModalFooter, null, hasRetry && !isExecutionInProgress && isExecutionFailed ? /* @__PURE__ */ React.createElement(Button, { label: localized.bulkStepExecutionSummaryModalRetry, onClick: handlePrevClick }) : /* @__PURE__ */ React.createElement(React.Fragment, null), /* @__PURE__ */ React.createElement(
      Button,
      {
        color: "primary",
        label: localized.bulkStepExecutionSummaryModalConfirm,
        onClick: handleNextClick,
        disabled: isExecutionInProgress
      }
    )));
  };
}
export {
  withBulkStepExecutionSummary
};
//# sourceMappingURL=BulkExecutionStepModal.js.map
